import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';
import { reportError } from '~/utilities/errorReporting';

export const ONBOARDING_PERIOD_IN_DAYS = 29;

/**
 * Verifies if the user is still in the onboarding period
 *
 * @param createdAt ISO8601 representation of the date
 * @returns boolean
 */
export const isOnboarding = (createdAt: string | null): boolean => {
  if (createdAt === null) {
    return false;
  }

  const parsedDate = parseISO(createdAt);

  if (!isValid(parsedDate)) {
    reportError(
      new Error(`Invalid date format: ${createdAt}. Please provide a valid ISO8601 date string.`),
      {
        pillar: 'growth',
        product: 'onboarding',
      },
    );
  }

  return differenceInCalendarDays(new Date(), parseISO(createdAt)) <= ONBOARDING_PERIOD_IN_DAYS;
};
